import type { IconSvgObject } from './types';

const StepOutIcon: IconSvgObject = [
  ["path", { d: "M3 21H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 18V8.50911C12 7.40454 12.8954 6.50911 14 6.50911H20.1411M18.5065 4L21 6.50911L18.5065 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default StepOutIcon;
